import { useState, useCallback, useEffect } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { useSelector, useDispatch } from 'react-redux';
import { AddBeneficiary, BeneficiariesContainer, Editables } from './beneficiaries.styles';
import CardBeneficiaries from 'src/components/features/investor/dashboard/myProfile/beneficiaries/cardBeneficiaries/cardBeneficieries';
import CreateBeneficiary from 'src/components/shared/modals/beneficiaries/CreateBeneficiary';
import { createBeneficiary } from 'src/graphql/customized_mutations';
import { deleteBeneficiary, createEachBeneficiary } from 'src/store/Profile/profile.slice';

export default function Beneficiaries({ beneficiariesInformation = [], onRefreshData }) {
  const user = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  const [editable, setEditable] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [beneficiaries, setBeneficiaries] = useState(beneficiariesInformation || []);
  const [totalPercentage, setTotalPercentage] = useState(0);
  const [beneficiaryData, setBeneficiaryData] = useState({
    investorId: user.id,
    firstName: '',
    lastNameP: '',
    lastNameM: '',
    relationship: '',
    percentage: 0,
    street: '',
    numExt: '',
    numInt: '',
    country: '',
    state: '',
    district: '',
    postalCode: ''
  });
  const handleCreateBeneficiary = useCallback(async () => {
    try {
      const totalAssigned = beneficiaries.reduce(
        (total, beneficiary) => total + beneficiary.percentage,
        0
      );
      if (totalAssigned + beneficiaryData.percentage > 1) {
        alert('El porcentaje total excede el 100% disponible. Favor de validar');
        return;
      }
      const result = await API.graphql(
        graphqlOperation(createBeneficiary, { input: beneficiaryData })
      );
      const createdBeneficiary = result.data.createBeneficiary;
      addBeneficiary(createdBeneficiary);
      setBeneficiaries((prevBeneficiaries) => [...prevBeneficiaries, createdBeneficiary]);
      setModalIsOpen(false);
      setTotalPercentage((prevPercentage) => prevPercentage + createdBeneficiary.percentage);
    } catch (error) {
      console.error(error);
    }
  }, [beneficiaryData, totalPercentage]);
  const beneficiariesList = beneficiariesInformation?.data?.getInvestor?.beneficiaries?.items;
  useEffect(() => {
    let beneficiariesList = beneficiariesInformation?.data?.getInvestor?.beneficiaries?.items;
    if (beneficiariesList) {
      setBeneficiaries(beneficiariesList);
      let total = 0;
      beneficiariesList.forEach((beneficiary) => {
        total += beneficiary.percentage;
      });
      setTotalPercentage(total);
    }
  }, [beneficiariesInformation]);

  const addBeneficiary = () => {
    setModalIsOpen(true);
  };
  const handleEdit = () => {
    setEditable(true);
  };
  const handleDeleteBeneficiary = (id) => {
    dispatch(deleteBeneficiary(id));
  };
  return (
    <BeneficiariesContainer>
      <CreateBeneficiary
        onRefreshData={onRefreshData}
        showModal={modalIsOpen}
        beneficiaryData={beneficiaryData}
        setBeneficiaryData={setBeneficiaryData}
        onClose={() => setModalIsOpen(false)}
        onConfirm={() => handleCreateBeneficiary()}
      />
      <AddBeneficiary totalPercentage={totalPercentage}>
        <button disabled={Math.round(totalPercentage) === 1} onClick={addBeneficiary}>
          Agregar beneficiario
        </button>
      </AddBeneficiary>
      {beneficiariesList && beneficiariesList.length > 0 ? (
        beneficiariesList.map((beneficiary, index) => (
          <CardBeneficiaries
            onRefreshData={onRefreshData}
            key={index}
            beneficiaryData={beneficiary}
            setBeneficiaryData={setBeneficiaryData}
            editData={handleEdit}
            onDelete={handleDeleteBeneficiary}
          />
        ))
      ) : (
        <h3>Aún no tienes beneficiarios agregados.</h3>
      )}
    </BeneficiariesContainer>
  );
}
